<template>
  <div id="home-dashboard">
    <div class="row">
      <div class="col-md-3 mb-4">
        <div class="card bg-primary text-white">
          <div class="card-body">
            <h5>Users :</h5>
            <p>{{countUser}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="card bg-primary text-white">
          <div class="card-body">
            <h5>Orders :</h5>
            <p>{{countOrder}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="card bg-primary text-white">
          <div class="card-body">
            <h5>Services :</h5>
            <p>{{countService}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="card bg-primary text-white">
          <div class="card-body">
            <h5>Shops :</h5>
            <p>{{countShop}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h2>User data</h2>
            <div class="chart">
              <UserChart
                :chart-data="userCollection"
                :options="options"
              ></UserChart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h2>User data</h2>
            <div class="chart">
              <UserChart
                :chart-data="userCollection"
                :options="options"
              ></UserChart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserChart from "./charts/UserChart";
// import OrderChart from "./charts/OrderChart";
import axios from "axios";
import swal from "sweetalert";

export default {
  components: {
    UserChart,
    // OrderChart
  },
  data() {
    return {
      userCollection: {},
      user: {
        labels: [],
        userPerCategory: [],
      },
      options: {},
      countUser: null,
      countOrder: null,
      countService: null,
      countShop: null,
    };
  },
  mounted() {
    axios
      .get("http://127.0.0.1:3000/api/dashboard/users")
      .then((res) => {
        console.log(res.data);
        this.countUser = res.data.countUser,
        this.countOrder = res.data.countOrder,
        this.countService = res.data.countService,
        this.countShop = res.data.countShop,
        this.user.userPerCategory = res.data.data.map((e) => e["count"]);
        this.user.labels = res.data.data.map((e) => e["_id"].toUpperCase());
        this.fillDataUser();
      })
      .catch((err) => {
        swal("Oops", err.toString(), "error");
      });
  },
  methods: {
    fillDataUser() {
      this.userCollection = {
        labels: this.user.labels,
        datasets: [
          {
            label: "Total",
            data: this.user.userPerCategory,
            backgroundColor: [
              "rgb(54, 162, 235)",
              "rgb(255, 205, 86)",
              "rgb(255, 99, 132)",
            ],
          },
        ],
        borderWidth: 1,
      };
      this.options = {
        plugins: {
          title: {
            display: true,
            text: "Custom Chart Title",
          },
        },
      };
    },
  },
};
</script>

<style lang="scss">
.chart {
  max-width: 100%;
}
</style>